<template>
  <div class="m-l-10">
    <TooltipView
      type="is-dark"
      :label="tooltip"
      :active="!!tooltip"
      :multilined="isMultilinedTooltip"
      :position="tooltipPosition"
      :append-to-body="appendToBody"
    >
      <ButtonView
        :class="buttonClass"
        :disabled="disabled"
        :type="type"
        :loading="loading"
        :icon-pack="`cls cls-${icon}`"
        :icon-right="`${icon}`"
        @click.prevent.stop="onClick"
        :data-e2e="dataE2e"
        :size="size"
      />
      <div
        v-if="badgeContent"
        class="badge has-background-danger has-text-white is-absolute is-size-6"
      >
        {{ badgeContent }}
      </div>
    </TooltipView>
  </div>
</template>

<script>
import ButtonView from '@/modules/core/ui/components/wrappers/ButtonView.vue';
import TooltipView from '@/modules/core/ui/components/wrappers/TooltipView.vue';
import { ButtonType } from '@/modules/core/app/enums/button/ButtonType';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'ActionIcon',
  components: { TooltipView, ButtonView },
  props: {
    actionFn: { type: Function },
    cellData: [String, Object, Number],
    icon: { type: String, required: true },
    type: { type: String, default: 'is-primary' },
    size: {
      type: String,
      required: false,
      validator: (prop) => ['is-small', 'is-medium', 'is-large'].includes(prop)
    },
    tooltip: { type: String },
    loading: { type: Boolean, default: false },
    tooltipPosition: { type: String, default: 'is-bottom' },
    isMultilinedTooltip: { type: Boolean },
    disabled: { type: Boolean, default: false },
    appendToBody: { type: Boolean, default: false },
    badgeContent: { type: [String, Number] },
    dataE2e: {
      type: String
    }
  },
  computed: {
    buttonClass() {
      return this.type === ButtonType.IS_DANGER_GHOST ? 'icon-button' : 'icon-button is-light';
    }
  },
  methods: {
    onClick() {
      if (this.actionFn && !this.disabled) {
        this.actionFn(this.cellData);
      }
    }
  }
};
</script>

<style scoped>
.badge {
  top: var(--ce--8px);
  right: var(--ce--8px);
  padding: 0;
  border-radius: 50%;
  width: var(--ce-18px);
  height: var(--ce-18px);
  line-height: var(--ce-16px);
  text-align: center;
  z-index: var(--ce-z-index-badge);
}

@media (max-width: CE_MOBILE) {
  .icon-button {
    width: var(--ce-40px) !important;
    height: var(--ce-40px) !important;
  }
}
</style>
